export const deliverConstants = {
    GET_DELIVER_LOGS: "GET_DELIVER_LOGS_LIST",
    GET_DELIVER_LOGS_SUCCESS: "GET_DELIVER_LOGS_LIST_SUCCESS",
    GET_DELIVER_LOGS_FAILURE: "GET_DELIVER_LOGS_LIST_FAILURE",
};
